import { getContactsQuantityMultiplier, getMinimumNumberOfPurchasableContacts, getPurchasedNonMarketingContactsQuantity } from 'pricing-pages-lib/utils/contactsUtils';
import { getAdditionalUnitsInProductLineFromProductInventory } from 'pricing-pages-lib/utils/productInventoryUtils';
import { getIsMarketingContactsSku } from 'pricing-pages-lib/utils/productsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { createSelector } from 'reselect';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { marketingContactsOnRenewalSelector } from './MarketingContactsSelectors';
import { skuSelector } from './ProductsSelectors';
import { transformState } from './SelectorUtils';
export const numContactsInCrmSelector = state => {
  const {
    numContactsInCrm
  } = state;
  return numContactsInCrm;
};
// Returns the contacts quantity multiplier for the additionalUnitMerchId of the activeMerchId
export const contactsQuantityMultiplierSelector = createSelectorFromUtil(getContactsQuantityMultiplier, transformState);
export const purchasedNonMarketingContactsQuantitySelector = createSelectorFromUtil(getPurchasedNonMarketingContactsQuantity, transformState);
export const includedAdditionalUnitsSelector = (state, {
  quantityPackSkuId
}) => {
  return skuSelector(state, {
    skuId: quantityPackSkuId
  }).includedWithProductVersion;
};
const totalOwnedMarketingContactsInCurrentPlanSelector = (state, {
  quantityPackSkuId
}) => {
  const packagedQuantities = includedAdditionalUnitsSelector(state, {
    quantityPackSkuId
  });
  const ownedQuantity = getAdditionalUnitsInProductLineFromProductInventory(transformState(state), {
    productLine: MARKETING,
    quantityPackApiName: 'additional-marketing-contacts'
  });
  return ownedQuantity || 0 + packagedQuantities;
};
export const minPurchasableContactsSelector = createSelector([includedAdditionalUnitsSelector, numContactsInCrmSelector, marketingContactsOnRenewalSelector, contactsQuantityMultiplierSelector, purchasedNonMarketingContactsQuantitySelector, (state, {
  quantityPackSkuId
}) => getIsMarketingContactsSku(transformState(state), {
  skuId: quantityPackSkuId
}), totalOwnedMarketingContactsInCurrentPlanSelector], (includedAdditionalUnits, numContactsInCrm, marketingContactsOnRenewal, contactsQuantityMultiplier, purchasedContactsQuantity, isMarketingContactsSku, totalOwnedMarketingContactsInCurrentPlan) => {
  return getMinimumNumberOfPurchasableContacts({
    includedAdditionalUnits,
    numContactsInCrm,
    marketingContactsOnRenewal: marketingContactsOnRenewal || 0,
    contactsQuantityMultiplier,
    purchasedContactsQuantity,
    isMarketingContactsSku,
    totalOwnedMarketingContactsInCurrentPlan
  });
});